module.exports = __webpack_public_path__ + "img/heart.1d6c2bfc.svg";